import { Avatar, Box, Button, Grid, makeStyles, Typography } from "@material-ui/core";
import LaunchIcon from "@material-ui/icons/Launch";
import { Link } from "react-router-dom";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { useReputationSelector } from "src/context/reputationContext";
import { numberWithCommas } from "src/services/utils";
import { exchanges, suggestionsConfig } from "./config";

const useStyles = makeStyles((theme) => ({
  rootItem: {
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-start",
      flexDirection: "column",
    },
  },
  exchangeItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: theme.palette.primary.main,
    textDecoration: "none",
  },
  figure: {
    color: theme.palette.text.hint,
    fontSize: "16px",
    fontWeight: 500,
  },
}));

export default function ReputationSuggestions() {
  const cls = useStyles();

  const rank = useReputationSelector((state) => {
    if (!state.reputationUser) return [];
    return state.reputationUser.userRank;
  });

  const suggestions = useReputationSelector((state) => {
    if (!state.reputationSuggestions) return [];
    return state.reputationSuggestions.suggestions;
  });

  function checkRank(item) {
    if (item.rank > rank) {
      return true;
    } else if (item.rank === 5) {
      return false;
    }
  }

  const TravaSuggestionItem = ({ title, link, text }) => {
    return (
      <Box display="flex" className={cls.rootItem}>
        <Typography color="textSecondary">{title}</Typography>
        <Button
          fullWidth
          color="primary"
          variant="contained"
          component="a"
          href={link}
          target="_blank"
          rel="nofollow noopener"
          style={{ maxWidth: 150 }}
        >
          {text} &nbsp;
          <LaunchIcon style={{ fontSize: 16 }} />
        </Button>
      </Box>
    );
  };

  const data = suggestions.filter(checkRank);

  return (
    <PaperWrapper title="Reputation Suggestions">
      <Box my={2}>
        {data.map((item, index) => (
          <Box key={index} mb={1}>
            <Typography color="textSecondary">
              To reach rank <span className={cls.figure}>{item.rank}</span>, you need to hold or stake more&nbsp;
              <span className={cls.figure}>{numberWithCommas(item.increase_amount, 2)}</span> TRAVA for{" "}
              <span className={cls.figure}>{numberWithCommas(item.during_time / (3600 * 24), 2)}</span> days
            </Typography>
          </Box>
        ))}
      </Box>
      <Box mb={2}>
        <Typography color="secondary" variant="subtitle2">
          Buy TRAVA
        </Typography>
        <Grid container spacing={3} style={{ marginTop: "0.5rem" }}>
          {exchanges.map((exc) => (
            <Grid key={exc.id} item md xs={6}>
              <Link href={exc.link} target="_blank" rel="nofollow noopener" className={cls.exchangeItem}>
                <Avatar src={exc.img} alt={exc.title} style={{ width: 70, height: 70, marginBottom: "0.5rem" }} />
                <Typography variant="subtitle2" align="center" style={{ color: "#7994C1" }}>
                  {exc.title}
                </Typography>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box mb={1}>
        <Typography color="secondary" variant="subtitle2">
          Earn TRAVA rewards: Use these apps and claim rewards
        </Typography>
        {suggestionsConfig.map((element, index) => (
          <TravaSuggestionItem key={index} title={element["title"]} link={element["link"]} text={element["text"]} />
        ))}
      </Box>
    </PaperWrapper>
  );
}
